
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2297D0',
        accent: colors.lightBlue.accent1,
        secondary: '#D05B22',
        info: colors.blue.lighten1,
        warning: colors.amber.darken2,
        error: colors.red.accent4,
        success: colors.green.lighten2
      },
      dark: {
        primary: '#2297D0',
        accent: colors.lightBlue.accent1,
        secondary: '#D05B22',
        info: colors.blue.lighten1,
        warning: colors.amber.darken2,
        error: colors.red.accent4,
        success: colors.green.lighten2
      }
    }
  },
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js